import React, { useState, useCallback } from 'react'
import { Form, Collapse, Spinner } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import ArticleMainForm from '../ArticleMainForm'
import SizeSystems from '../SizeSytems/CopySize/SizeSystems'
import { useArticleDataState } from '../../../../stores/Configuration/ArticleDataProvider'
import useMountEffect from '../../../../utils/hooks/useMountEffect'
import OfficeMultiSelect from '../../../General/Office/OfficeMultiSelect'
import { useTranslation } from 'react-i18next'
import { ArrowBigIcon } from '../../../Icons/ArrowBigIcon'
import { colors } from '../../../../styles/colors'
import { StyledCollapseTrigger } from '../formHelper'

const CopyContentArea = () => {
  const {
    articleBaseObj,
    setArticleBaseObj,
    loadArticleData,
    loadedArticleData,
    setActionMode,
    sizeSystems,
    setSizeSystems,
    errorStates,
    loadingStates,
    selectedOfficeAvailabilities,
    setSelectedOfficeAvailabilities,
  } = useArticleDataState()
  const { t } = useTranslation()
  const { articleId } = useParams()
  const [sizesIsOpened, setSizesIsOpened] = useState(false)
  const [officeAvailabilitiesIsOpened, setOfficeAvailabilitiesIsOpened] =
    useState(false)

  const loadData = async () => {
    loadArticleData(articleId)
  }
  useMountEffect(() => {
    setActionMode('copy')
    loadData()
  })
  const handleClickCollapse = useCallback((setData) => {
    setData((prev) => !prev)
  }, [])

  const renderOfficeAvailabilities = () => {
    return (
      <>
        <StyledCollapseTrigger
          className='d-flex'
          onClick={() => handleClickCollapse(setOfficeAvailabilitiesIsOpened)}
        >
          <ArrowBigIcon
            variant={officeAvailabilitiesIsOpened ? 'down' : 'right'}
            color={colors.textColor}
          />
          <h2 className='h1'>{t('articleAdmin:activateArticleForUnits')}</h2>
        </StyledCollapseTrigger>
        <Collapse in={officeAvailabilitiesIsOpened}>
          <div className='spacing-down'>
            <OfficeMultiSelect
              selectedOfficeIds={selectedOfficeAvailabilities}
              setSelectedOfficeIds={setSelectedOfficeAvailabilities}
            />
          </div>
        </Collapse>
      </>
    )
  }
  const renderSizes = () => {
    return (
      <>
        <StyledCollapseTrigger
          onClick={() => handleClickCollapse(setSizesIsOpened)}
        >
          <h2 className='h1'>
            <ArrowBigIcon
              variant={sizesIsOpened ? 'down' : 'right'}
              color={colors.textColor}
            />
            {t('articleAdmin:availableSizeSystems')}
          </h2>
        </StyledCollapseTrigger>
        <Collapse in={sizesIsOpened}>
          <div className='spacing-down'>
            <SizeSystems
              articleId={articleId}
              sizeSystems={sizeSystems}
              setSizeSystems={setSizeSystems}
              loadingStates={loadingStates}
              errorStates={errorStates}
            />
          </div>
        </Collapse>
      </>
    )
  }
  if (!loadedArticleData) {
    return (
      <div className='d-flex align-items-center justify-content-center'>
        <Spinner animation='border' variant='primary' />
      </div>
    )
  }
  return (
    <Form>
      <ArticleMainForm
        articleBaseObj={articleBaseObj}
        setArticleBaseObj={setArticleBaseObj}
        loadingStates={loadingStates}
        errorStates={errorStates}
      />
      {renderSizes()}
      {renderOfficeAvailabilities()}
    </Form>
  )
}

export default CopyContentArea
